import React from 'react';
import { Carousel } from 'nuka-carousel';
import { motion } from 'framer-motion';
import { animationParams, animationVariants } from 'fragments';
import { slideCompleteABAContents, slideCompleteABAImages } from './constants';
import { useWidth } from 'utils';
import { StreamLineScroll } from './streamLineScroll';
import { LandingSvg } from '../../../../../assets';

export const CompleteABACare = () => {
    const width = useWidth();

    const returnSlidesToShow = () => {
        if (width < 768) {
            return 1;
        } else if (width < 968) {
            return 2;
        } else if (width < 1280) {
            return 2.5;
        } else {
            return 3;
        }
    };

    return (
        <div>
            <div className="complate-aba-care-wrapper">
                <div className="container">
                    <div style={{ overflow: 'hidden' }}>
                        <motion.h2 className="complate-aba-care-title" {...animationParams} variants={animationVariants.titleVariant}>
                            One Platform. Two Core Workflows. <br />
                            <span style={{ color: '#0C66E4' }}>Complete ABA Care.</span>
                        </motion.h2>
                    </div>

                    <div style={{ overflow: 'hidden' }}>
                        <motion.p className="complate-aba-care-text" {...animationParams} variants={animationVariants.titleVariant}>
                            Whether you're documenting clinical progress or managing schedules and billing, <br />
                            TherapyLake keeps every part of your ABA workflow in sync from data collection to operations.
                        </motion.p>
                    </div>

                    <div style={{ width: width <= 1279 ? '100%' : '50%', padding: width <= 1279 ? '12px 0 24px' : '' }}>
                        <div className={`complate-aba-care-content-side-flag`}>Practice Management</div>
                        <h3 className={`complate-aba-care-content-side-title`}>Streamline Operations From Intake to Reimbursement</h3>
                        <p className={`complate-aba-care-content-side-text`}>
                            Simplify scheduling, automate billing, and manage staff in one intelligent system that keeps your practice
                            organized, compliant, and efficient
                        </p>
                    </div>
                </div>

                {width <= 1279 ? (
                    <div style={{ borderBottom: '1px solid #FAF5FF', paddingBottom: 24, marginBottom: 12 }}>
                        <Carousel className="carousel-box" showArrows="hover" scrollDistance="slide" wrapMode="nowrap">
                            {slideCompleteABAContents.map((item, index) => (
                                <div
                                    key={index}
                                    className="slider-card-box"
                                    style={{ flex: `0 0 calc(${100 / returnSlidesToShow()}% - 24px)`, marginRight: 24 }}
                                >
                                    <img
                                        style={{ border: '8px solid rgb(238, 245, 254)' }}
                                        className="slider-card-image"
                                        src={item.image}
                                        alt="slider-image"
                                    />

                                    <div style={{ marginLeft: 8 }}>
                                        <h4 style={{ color: '#1668E8' }}>{item.title}</h4>
                                        <p>{item.text}=</p>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </div>
                ) : (
                    <div style={{ borderBottom: '1px solid #FAF5FF' }}>
                        <StreamLineScroll cardData={slideCompleteABAContents} images={slideCompleteABAImages} />
                    </div>
                )}
            </div>
        </div>
    );
};
